import { autorun, computed, observable, makeObservable } from 'mobx';
import { CSS } from '../../components/license.banner/license.banner.style';
import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { IMithrilComponent } from '../mithril.component';

export class LicenseBannerComponent extends IMithrilComponent {
	name = 'LicenseBanner';
	@observable bannerVisible: boolean = false;
	private readonly disposer: () => void;

	constructor() {
		super();
		makeObservable(this);

		autorun(() => {
			this.bannerVisible = Services.License.hasNoLicense;
		});
	}

	onremove() {
		if (this.disposer) {
			this.disposer();
		}
	}

	@computed get nodes(): MithrilVNode {
		if (this.bannerVisible) {
			return m('div', { className: CSS.alert }, [
				m('span', { className: CSS.License }, [
					Translate(T.LICENSE_CHECK_FAILED_TEXT),
					m(
						'a',
						{
							className: CSS.alertHref,
							href: 'https://ikegps.zendesk.com/hc/en-us/articles/24400055764237-How-to-Admin-IKE-Office-Pro-User-Seats-Using-IKE-Access-FAQ',
							target: '_blank',
						},
						Translate(T.LICENSE_CHECK_FAILED_LINK)
					),
					'.',
				]),
				m('span', { className: CSS.License }, [
					Translate(T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT),
					m(
						'a',
						{
							className: CSS.alertHref,
							href: `mailto:${Translate(T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)}`,
						},
						Translate(T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)
					),
					'.',
				]),
				m(
					'button',
					{
						className: CSS.closeButton,
						onclick: () => {
							Services.License.hasNoLicense = false;
							this.bannerVisible = false;
						},
						title: T.CLOSE,
					},
					[
						Translate(T.DISMISS),
						Icon.view(MaterialIcon.CLOSE, {
							className: CSS.closeIcon,
						}),
					]
				),
			]);
		}
		return null;
	}
}
